export const DEFAULT_AUTHENTICATED_PATH = '/company-cockpit'

export function resolvePostLoginPath (redirect) {
  if (typeof redirect !== 'string') return DEFAULT_AUTHENTICATED_PATH

  const path = redirect.trim()
  if (!path || !path.startsWith('/') || path.startsWith('//') || path === '/login' || path.startsWith('/login?')) {
    return DEFAULT_AUTHENTICATED_PATH
  }

  return path === '/' ? DEFAULT_AUTHENTICATED_PATH : path
}
